module.exports = __webpack_public_path__ + "4533224a798b5728649ca94a82819d36.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/containers/Camps/camps1.jpg
// module id = 1207
// module chunks = 0